import { setCurrentSuggestions } from '../actions/publicActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
export default mutator(setCurrentSuggestions, function (actionMessage) {
    var suggestionSet = actionMessage.suggestionSet;
    getStore().currentSuggestions = suggestionSet;
});
//# sourceMappingURL=setCurrentSuggestionsMutator.js.map